// NOTICE: KAPTION-INTEGRATION
// API client for Kaption Scheduled Messages
/* global axios */

// Get all scheduled messages for a conversation
export const getScheduledMessages = (accountId, conversationId) => {
  return axios.get(
    `/api/v1/accounts/${accountId}/conversations/${conversationId}/kaption_scheduled_messages`
  );
};

// Get a single scheduled message
export const getScheduledMessage = (accountId, conversationId, messageId) => {
  return axios.get(
    `/api/v1/accounts/${accountId}/conversations/${conversationId}/kaption_scheduled_messages/${messageId}`
  );
};

// Create a new scheduled message
export const createScheduledMessage = (accountId, conversationId, data) => {
  return axios.post(
    `/api/v1/accounts/${accountId}/conversations/${conversationId}/kaption_scheduled_messages`,
    data
  );
};

// Cancel a scheduled message
export const cancelScheduledMessage = (
  accountId,
  conversationId,
  messageId
) => {
  return axios.delete(
    `/api/v1/accounts/${accountId}/conversations/${conversationId}/kaption_scheduled_messages/${messageId}`
  );
};

// Get available timezones
export const getTimezones = (accountId, conversationId) => {
  return axios.get(
    `/api/v1/accounts/${accountId}/conversations/${conversationId}/kaption_scheduled_messages/timezones`
  );
};

// Get all scheduled messages across all conversations (account-level)
export const getAccountScheduledMessages = (accountId, params = {}) => {
  return axios.get(`/api/v1/accounts/${accountId}/kaption_scheduled_messages`, {
    params,
  });
};

// Get count of all scheduled messages across all conversations (account-level)
export const getAccountScheduledMessagesCount = accountId => {
  return axios.get(
    `/api/v1/accounts/${accountId}/kaption_scheduled_messages/count`
  );
};

export default {
  getScheduledMessages,
  getScheduledMessage,
  createScheduledMessage,
  cancelScheduledMessage,
  getTimezones,
  getAccountScheduledMessages,
  getAccountScheduledMessagesCount,
};
